import {
  ClientSticky,
  StickyDraft,
} from 'views/EMR/Sticky/types';
import orderBy from 'lodash/orderBy';
import partition from 'lodash/partition';
import sortBy from 'lodash/sortBy';

function toTimestamp(value?: string): number {
  return Date.parse(value ?? '') || 0;
}

export function sortStickyIds(
  persistedById: Record<number, ClientSticky>,
): number[] {
  const items = Object.values(persistedById);

  const [
    tempItems,
    persistedItems,
  ] = partition(items, (item) => (item.stickyId ?? 0) < 0);

  const sortedTempItems = sortBy(tempItems, (item) => item.stickyId ?? 0);
  const sortedPersistedItems = orderBy(
    persistedItems,
    [
      (item) => item.isPinned,
      (item) => toTimestamp(item.updatedOn),
    ],
    ['desc', 'desc'],
  );

  return [
    ...sortedTempItems,
    ...sortedPersistedItems,
  ].map((item) => item.stickyId ?? 0);
}

export function draftsEqual(a: StickyDraft, b: StickyDraft): boolean {
  return (
    a?.title === b?.title
    && a?.content === b?.content
    && a?.isPinned === b?.isPinned
  );
}
